import React, { useEffect, useState } from 'react'
import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { Form, Formik } from 'formik';
import OtpInput from 'react-otp-input';
import * as Yup from "yup";
import AdminService from 'Api/Admin';
import { useApiMutation } from 'services/useApiMutation';
import { useDisableEmailCode, useDisableEmailCodeManual, useSendEmailCode } from 'Api/Common/CommonComponents';
import DefaultButton from 'Components/Buttons/DefaultButton';

const OTPSchema = Yup.object().shape({
    rememberOTP: Yup.boolean()
});

const TwoFAModal = ({ showOTPModal, setShow2FAModal, handleOTPSubmit = () => { }, setVerifyEnable, otp, setOtp, skipAutoEmailFlow, showRememberMe = true, buttonPress = false, setShowQRModal, fetchProfileData, error, setError = () => { }, setVerifyType, generateQR }) => {

    const [emailSent, setEmailSent] = useState(false);
    const [useMailCode, setUseMailCode] = useState(false);
    const [otpMethod, setOtpMethod] = useState(null);
    const [shouldFetchManualDisableEmail, setShouldFetchManualDisableEmail] = useState(false);
    const [timer, setTimer] = useState(300);
    const { trigger: sendEmailCode } = useSendEmailCode();
    const {
        data: manualDisableEmailResponse,
    } = useDisableEmailCodeManual(shouldFetchManualDisableEmail);

    const shouldFetchDisableEmail =
        fetchProfileData?.profileList?.isEnabled == 1 && fetchProfileData?.twoFactor === "email" &&
        showOTPModal;

    const {
        data: disableEmailResponse,
        mutate: disableEmailCode,
    } = useDisableEmailCode(shouldFetchDisableEmail);

   useEffect(() => {
    if (!disableEmailResponse?.status) return;

    setEmailSent(true);
    setUseMailCode(true);
    setVerifyType(disableEmailResponse.two_factor_mail_enable);

    const endTime = Date.now() + 300 * 1000;

    localStorage.setItem("otpTimerEnd", endTime);
    localStorage.setItem("otpEmailSent", "true");

    setTimer(300);
}, [disableEmailResponse]);

    useEffect(() => {
        if (!manualDisableEmailResponse?.status) return;

        console.log(
            "DISABLE EMAIL API RESPONSE:",
            manualDisableEmailResponse
        );

        setVerifyType(
            manualDisableEmailResponse.two_factor_mail_enable
        );

        setShouldFetchManualDisableEmail(false);
    }, [manualDisableEmailResponse]);


    useEffect(() => {
        if (showOTPModal) {
            setError(null);
        }
    }, [showOTPModal]);

    useEffect(() => {
        const savedEndTime = localStorage.getItem("otpTimerEnd");
        const savedEmailSent = localStorage.getItem("otpEmailSent");

        if (
            savedEndTime &&
            savedEmailSent === "true"
        ) {
            const remaining = Math.floor(
                (Number(savedEndTime) - Date.now()) / 1000
            );

            if (remaining > 0) {
                setEmailSent(true);
                setTimer(remaining);
            } else {
                localStorage.removeItem("otpTimerEnd");
                localStorage.removeItem("otpEmailSent");

                setEmailSent(false);
                setTimer(300);
            }
        }
    }, []);

    useEffect(() => {
        let interval;

        if (emailSent && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [emailSent, timer]);

    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m}:${s < 10 ? "0" : ""}${s}`;
    };
    const handleEmailLink = () => {
        setEmailSent(false);
        sendEmailCode({})
            .then((response) => {
                if (response?.status) {
                    localStorage.removeItem("otpTimerEnd");
                    const verifyType = response.verification_type
                    setVerifyEnable(verifyType)
                    setUseMailCode(true);
                    setEmailSent(true);
                    const endTime = Date.now() + 300 * 1000;
                    localStorage.setItem("otpTimerEnd", endTime);
                    localStorage.setItem("otpEmailSent", "true");
                    setTimer(300);
                }
                else {
                    setError('onjuiste code')
                }
            })
            .catch((error) => {
                console.error(error);

            });
    }

    useEffect(() => {
        if (skipAutoEmailFlow) return;

        if (
            (fetchProfileData?.twoFactors === 'email')
            && !useMailCode
            && showOTPModal
        ) {
            handleEmailLink();
        }



    }, [fetchProfileData, showOTPModal, skipAutoEmailFlow]);

    return (
        <Modal isOpen={showOTPModal} className="modal-centered login-OTP-modal">

            <ModalHeader toggle={!showRememberMe ? (() => setShow2FAModal(false)) : (false)} className='modalHeader modal-header-color'>
                <div className="logo">
                    <div></div>
                </div>
                <div>
                    <span style={{ color: '#878EA6', fontWeight: 500 }}>2FA {"  "}</span>
                    <span style={{ color: '#878EA6', fontWeight: 500 }}>Two-factor authentication</span>
                </div>
            </ModalHeader>

            <ModalBody className='modalBody-centered'>

                <Formik
                    initialValues={{
                        rememberOTP: false,
                    }}
                    validationSchema={OTPSchema}
                    onSubmit={handleOTPSubmit}
                >
                    {({ setFieldValue, handleSubmit, values, handleBlur, errors, touched }) => (
                        <Form onSubmit={handleSubmit} className="login-OTP-form">
                            <FormGroup className='input'>
                                <Label>


                                    <div className='text-center'>
                                        {skipAutoEmailFlow
                                            ? "Voer de code in die wordt weergegeven in uw Authenticator-app op uw mobiele apparaat."
                                            : otpMethod === "email"
                                                ? "Voer de beveiligingscode uit uw mail in."
                                                : otpMethod === "auth"
                                                    ? "Voer de code in die wordt weergegeven in uw Authenticator-app op uw mobiele apparaat."
                                                    : (fetchProfileData?.twoFactor === "email" || fetchProfileData?.twoFactors === "email")
                                                        ? "Voer de beveiligingscode uit uw mail in."
                                                        : "Voer de code in die wordt weergegeven in uw Authenticator-app op uw mobiele apparaat."
                                        }
                                    </div>

                                </Label>
                                <OtpInput
                                    value={otp}
                                    onChange={(value) => {
                                        setOtp(value);
                                        setError("");
                                    }}
                                    numInputs={6}
                                    inputType="tel"
                                    renderInput={(props) => <input {...props} className="otp-input" />}
                                />


                                {showRememberMe && (
                                    <Label className="label-2">
                                        <Input
                                            onChange={(e) => setFieldValue('rememberOTP', e.target.checked)}
                                            id="2fa-code"
                                            name="2fa-code"
                                            type="checkbox"
                                            value={values.rememberOTP}
                                            onBlur={handleBlur}
                                        />
                                        <div>
                                            <div>Onthoud dit apparaat</div>
                                            <div style={{ color: '#80808091', fontWeight: 400, fontSize: '12px' }}>Net aan bevolen voor openbare of gedeelde computers</div>
                                        </div>
                                    </Label>
                                )}


                            </FormGroup>

                            <ModalFooter className={`d-flex align-items-center justify-content-center border-bottom-0 py-4 ${showRememberMe ? "mt-4" : "mt-5"}`}>
                                <div className='text-center'>
                                    {error ? (
                                        <p className='text-danger'>{error}</p>
                                    ) : null
                                    }
                                    <div className="d-flex justify-content-center mt-2">

                                        <p style={{ color: "#4291CF", textAlign: "center", marginBottom: "15px" }}>

                                            {(fetchProfileData?.twoFactors === "email" || fetchProfileData?.twoFactor === "email") && !skipAutoEmailFlow ? (
                                                <a
                                                    href="#"
                                                    className="text-decoration-underline ms-1 otpModal"
                                                    
                                                    onClick={(e) => {
                                                        e.preventDefault();

                                                        const adminId =
                                                            fetchProfileData?.user?.iAdminId ||
                                                            fetchProfileData?.profileList?.iAdminId;
                                                        if (!adminId) return;

                                                        setEmailSent(false);
                                                        setUseMailCode(true);
                                                        setError("");

                                                        localStorage.removeItem("otpTimerEnd");
                                                        setShow2FAModal(false);

                                                        setTimeout(() => {
                                                            generateQR(adminId);
                                                            setShowQRModal(true);
                                                        }, 100);
                                                    }}
                                                >
                                                    Gebruik code via uw Authenticator-app
                                                </a>

                                            ) : (
                                                !skipAutoEmailFlow && !emailSent && (
                                                    <a
                                                        href="#"
                                                        className="text-decoration-underline ms-1 otpModal"
                                                      
                                                        onClick={async (e) => {
                                                            e.preventDefault();
                                                            setOtpMethod("email");

                                                            if (
                                                                fetchProfileData?.profileList?.isEnabled === 1 &&
                                                                fetchProfileData?.twoFactor === ""
                                                            ) {
                                                                setShouldFetchManualDisableEmail(true);
                                                            }

                                                            if (fetchProfileData?.enabled === 1) {
                                                                handleEmailLink();
                                                            }
                                                        }}
                                                    >
                                                        Ontvang uw verificatie code per mail
                                                    </a>
                                                )
                                            )}

                                        </p>



                                    </div>


                                    {
                                        emailSent && (
                                            <p style={{ color: "#39A825", textAlign: "center", marginBottom: "15px" }}>

                                                {timer > 0 ? (
                                                    <span style={{ color: "#39A825" }}>
                                                        2fa e-mail verzonden. Opnieuw verzenden {formatTime(timer)}
                                                    </span>
                                                ) : (
                                                    <a
                                                        href="#"
                                                        style={{ textDecoration: "underline", color: "#4291CF" }}
                                                        onClick={async (e) => {
                                                            e.preventDefault();

                                                            if (fetchProfileData?.profileList?.isEnabled === 1) {
                                                                await disableEmailCode();
                                                            }
                                                            if (fetchProfileData.enabled === 1) {
                                                                handleEmailLink();
                                                            }
                                                        }}
                                                    >
                                                        Opnieuw verzenden
                                                    </a>
                                                )}
                                            </p>
                                        )
                                    }


                                    <DefaultButton disabled={buttonPress} type={otp?.length < 6 ? "button" : "submit"} color="link" className={"btn-color-style"} style={{ cursor: otp?.length < 6 ? "no-drop" : "pointer" }}>
                                        Bevestigen
                                    </DefaultButton>
                                </div>
                            </ModalFooter>
                        </Form>
                    )}
                </Formik>
            </ModalBody>


        </Modal >
    )
}

export default TwoFAModal;